import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';

import { Card, Tabs } from 'antd';
import ModelForm from './ModelForm';
import SiteFlowTable from './SiteFlowTable';
import DivisionTable from './DivisionTable';
import UserDetailActions from '../../Stores/UserDetail/Actions';

const { TabPane } = Tabs;

class UserDetailScreen extends React.PureComponent {
  componentDidMount() {
    const { match, setReslId } = this.props;

    if (match.params.action === 'create') {
      setReslId(0);
    } else if (match.params.action === 'update') {
      setReslId(parseInt(match.params.id, 10));
    }
  }

  componentDidUpdate() {}

  componentWillUnmount() {}

  render() {
    const { intl, match, model, modelIsLoading } = this.props;

    return (
      <Card
        title={`${intl.formatMessage({ id: 'user' })} ${model.username}`}
        loading={modelIsLoading}
      >
        <Tabs type="card" defaultActiveKey="general">
          <TabPane tab={intl.formatMessage({ id: 'general' })} key="general" forceRender>
            <ModelForm match={match} />
          </TabPane>
          <TabPane tab={intl.formatMessage({ id: 'site_flows' })} key="site_flows" forceRender>
            <SiteFlowTable match={match} />
          </TabPane>
          <TabPane tab={intl.formatMessage({ id: 'divisions' })} key="divisions" forceRender>
            <DivisionTable match={match} />
          </TabPane>
        </Tabs>
      </Card>
    );
  }
}

UserDetailScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  setReslId: PropTypes.func,
  model: PropTypes.shape({
    username: PropTypes.string,
    status: PropTypes.number
  }),
  modelIsLoading: PropTypes.bool
};

UserDetailScreen.defaultProps = {
  intl: {},
  match: {},

  setReslId() {},
  model: { username: '', status: 2 },
  modelIsLoading: false
};

const mapStateToProps = state => ({
  model: state.userDetail.model,
  modelIsLoading: state.userDetail.modelIsLoading
});

const mapDispatchToProps = dispatch => ({
  setReslId: resId => dispatch(UserDetailActions.userDetailSetResId(resId))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(UserDetailScreen));
